import { useContext } from 'react';

import { DebtConContext } from '@src/app/contexts/DebtCon';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import ReviewView from '@src/ui/views/debtCon/Review/ReviewView';

const Review = () => {
    const { loading } = useContext(DebtConContext);

    return (
        <EligibilityLayout loading={loading}>
            <ReviewView />
        </EligibilityLayout>
    );
};

export default Review;
